import { IStoreState } from '../../types'
import { getDriverById } from '../../state/reducers/drivers'
import { connect } from 'react-redux'
import DriverViewProvidersProducts from '../../components/drivers/DriverViewProvidersProducts'

const mapStateToProps = (state: IStoreState, ownProps: { operatorId: string }) => {
  const operator = getDriverById(state, ownProps.operatorId)
  return {
    operator
  }
}

export default connect(mapStateToProps)(DriverViewProvidersProducts)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverViewProvidersProducts.ts